"use strict";
$.fn.textfill = function (clean) {
    $('h2 a, h1 a, h5 a, p a.textfill', this).css('font-size', "").css('line-height', "");
    if (!clean) {
        textFill("h2 a", this);
        textFill("h1 a", this);
        textFill("h5 a", this);
        textFill("p a.textfill", this);
    }
    return this;
}


var textFill = function (sel, th) {
    var sizes = [];
    var ourTexts = $(sel, th);
    var fontSizepx = ourTexts.css('font-size') ? ourTexts.css('font-size') : '27px';
    var fontSizeInit = fontSizepx.replace(/[^-\d\.]/g, '');
    var fontSize = parseInt(fontSizeInit);
    for (var i = 0; i < ourTexts.length; i++) {
        var ourText = ourTexts[i];
        var maxHeight = $(ourText).parent().height();
        var maxWidth = $(ourText).parent().width();
        var textHeight;
        var textWidth;
        do {
            $(ourText).css('line-height', (fontSize + 4) + 'px');
            $(ourText).css('font-size', fontSize);
            textHeight = $(ourText).height();
            textWidth = $(ourText).width();
            fontSize = fontSize - 1;
        } while ((textHeight > maxHeight || textWidth > maxWidth) && fontSize > 10);
        fontSize++;
        sizes.push(fontSize);
    }
    var resultSize = Math.min.apply(null, sizes);
    ourTexts.css('font-size', resultSize);
    ourTexts.css('line-height', (resultSize + 4) + 'px');
}

// window.onresize = onResize;
window.addEventListener("orientationchange", function () {
    textFillResize();
    setTimeout(function () {
        textFillResize();
    }, 100);
    setTimeout(function () {
        textFillResize();
    }, 300);
    setTimeout(function () {
        textFillResize();
    }, 700);
});
var textFillResize = function () {
    if ($(window).width() < 768) {
        $('.text-fill-section').each(function () {
            $(this).textfill(true);
        });
    } else {
        $('.text-fill-section').each(function () {
            $(this).textfill(false);
        });
    }
};

$(window).resize(textFillResize);
textFillResize();

$(window).on("load", function () {
    textFillResize();
    setTimeout(function () {
        textFillResize();
    }, 1000);
});